module.exports = __webpack_public_path__ + "static/media/certificate_template_v2.be08a5a8.png";